import { useEffect, useState } from "react";
import "../ProjetoLicenciamentoAmbiental/Projeto.css";
import BannerPaginaInterna from "../BannerPaginaInterna/BannerPaginaInterna.js";
import Projetos from "../Projetos/Projetos.js";
import Contato from "../Contato/Contato.js";
import gerecResSol1 from "../../assets/img/projetos/gerecResSol1.png";
import gerecResSol2 from "../../assets/img/projetos/gerecResSol2.png";
import Servicos from "../Servicos/Servicos.js";
import { FaMountain, FaSeedling, FaWater, FaShieldAlt } from "react-icons/fa";

function ProjetoGereciamentoResiduosSolidos() {
  const [openItem, setOpenItem] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal-zoom");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  const itens = [
    {
      icon: <FaShieldAlt />,
      titulo: "Controle de Erosão",
      desc: "Redução dos processos erosivos e proteção do solo",
    },
    {
      icon: <FaMountain />,
      titulo: "Estabilização de Taludes",
      desc: "Segurança geotécnica e reconfiguração do terreno",
    },
    {
      icon: <FaSeedling />,
      titulo: "Recomposição Vegetal",
      desc: "Recuperação da cobertura vegetal e equilíbrio ambiental",
    },
    {
      icon: <FaWater />,
      titulo: "Disciplinamento Hídrico",
      desc: "Controle e direcionamento adequado das águas",
    },
  ];

  return (
<div className="bg-white">
      <BannerPaginaInterna
        tag="Resíduos sólidos"
        titulo="Gerenciamento de Resíduos Sólidos"
        descricao="Soluções técnicas para o gerenciamento eficiente de resíduos sólidos em ambientes minerários."
        textoBotao="Solicitar Orçamento"
        rotaBotao="https://wa.me/5532984053160?text=Olá, quero um orçamento para Gerenciamento de Resíduos Sólidos"
        mostrarBotaoOutline={true}
        textoBotaoOutline="Fale com Especialista"
        rotaBotaoOutline="https://wa.me/5532984053160?text=Olá, quero falar com um especialista em Gerenciamento de Resíduos Sólidos"
      />

      <main className="projetos-page py-5 container">
        <section className="s scroll-reveal-zoom">
          <div className="titulo-bloco">
            <h2>PGRS para Indústria</h2>
            <p>
              Como estruturar a gestão de resíduos e garantir conformidade
              ambiental desde a implantação
            </p>
          </div>

          <div className="scroll-reveal-zoom">
            <p>
              Empreendimentos industriais em fase de implantação enfrentam um
              desafio crítico: estruturar a{" "}
              <strong>gestão de resíduos sólidos</strong> de forma eficiente,
              garantindo{" "}
              <strong>conformidade com a legislação ambiental</strong>,{" "}
              <strong>redução de riscos</strong> e{" "}
              <strong>organização operacional</strong> desde o início da
              operação.
            </p>

            <p>
              A ausência de uma estrutura definida para a gestão de resíduos
              pode comprometer o avanço do{" "}
              <strong>processo de licenciamento ambiental</strong>, aumentar{" "}
              <strong>riscos ambientais</strong> e gerar{" "}
              <strong>impactos operacionais e financeiros</strong> futuros.
            </p>

            <p>
              Neste case, apresentamos como estruturamos o{" "}
              <strong>Plano de Gerenciamento de Resíduos Sólidos (PGRS)</strong>{" "}
              para um empreendimento do setor de bioenergia, em fase de
              implantação, viabilizando o avanço do processo de licenciamento
              ambiental.
            </p>

            <p>
              A empresa, voltada à produção de{" "}
              <strong>pellets de madeira</strong> como alternativa sustentável
              aos combustíveis fósseis, já possuía{" "}
              <strong>Licença Prévia</strong> emitida e necessitava atender às
              exigências para obtenção da <strong>Licença de Instalação</strong>
              . Para isso, desenvolvemos um <strong>PGRS completo</strong>,
              contemplando todas as etapas do gerenciamento de resíduos, desde a
              geração até a destinação final.
            </p>

            <p>
              O principal desafio foi estruturar, ainda na fase de projeto, um{" "}
              <strong>sistema completo de gerenciamento de resíduos</strong>{" "}
              capaz de atender integralmente às exigências legais, mesmo na
              ausência de dados operacionais. Foi necessário antecipar os{" "}
              <strong>fluxos de geração de resíduos</strong> e definir, de forma
              consistente, todas as etapas do gerenciamento, incluindo{" "}
              <strong>
                classificação, segregação, armazenamento, transporte e
                destinação final
              </strong>
              .
            </p>

            <p>
              Essa estruturação foi fundamental não apenas para garantir a{" "}
              <strong>conformidade legal</strong>, mas também para reduzir{" "}
              <strong>riscos ambientais e regulatórios</strong>, assegurando
              maior controle e segurança para a futura operação.
            </p>

            <p>
              Sem esse planejamento, o empreendimento poderia ter sua evolução
              comprometida, tanto pela possibilidade de não obtenção da licença
              quanto pela exposição a <strong>riscos de contaminação</strong>,{" "}
              <strong>passivos legais</strong> e{" "}
              <strong>ineficiências operacionais</strong>.
            </p>

            <p>
              Diante disso, o <strong>PGRS</strong> se consolida como uma{" "}
              <strong>ferramenta estratégica</strong> para viabilizar o
              empreendimento com{" "}
              <strong>segurança, organização e conformidade ambiental</strong>.
            </p>
          </div>

          <section className="images-section scroll-reveal-zoom">
            <div className="container">
              <div className="images-grid">
                <div className="image-card">
                  <img src={gerecResSol1} alt="" className="img-fluid" />
                </div>

                <div className="image-card">
                  <img src={gerecResSol2} alt="Imagem secundária" />
                </div>
              </div>
            </div>
          </section>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>Conformidade legal e eficiência na gestão de resíduos</h5>
            <p>
              O projeto foi desenvolvido com o objetivo de estruturar um{" "}
              <strong>PGRS completo</strong>, capaz de garantir{" "}
              <strong>conformidade com a legislação ambiental</strong> e{" "}
              <strong>eficiência na gestão de resíduos</strong> desde o início
              da operação.
            </p>

            <p>
              Alinhado às diretrizes da{" "}
              <strong>Política Nacional de Resíduos Sólidos</strong>, o plano
              foi concebido para estruturar uma gestão eficiente de todos os
              resíduos gerados no empreendimento, promovendo a{" "}
              <strong>redução na fonte</strong> e a{" "}
              <strong>otimização do uso de recursos</strong>. Além disso, foram
              estabelecidas diretrizes para assegurar a correta{" "}
              <strong>segregação</strong>, o{" "}
              <strong>acondicionamento adequado</strong> e a{" "}
              <strong>
                destinação final ambientalmente adequada e rastreável
              </strong>
              .
            </p>

            <p>
              O PGRS também incorpora ações voltadas à{" "}
              <strong>conscientização e engajamento dos colaboradores</strong>,
              por meio de <strong>programas de educação ambiental</strong>,
              fortalecendo a cultura de gestão de resíduos no ambiente de
              trabalho. Dessa forma, o plano garante o{" "}
              <strong>
                atendimento integral às exigências legais e normativas
              </strong>
              , contribuindo para uma operação mais{" "}
              <strong>organizada, segura e sustentável</strong>.
            </p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>
              Diagnóstico e Estruturação do PGRS: do planejamento à destinação
              final
            </h5>
            <p>
              Como o empreendimento ainda se encontrava em fase de implantação,
              o diagnóstico foi realizado com base na análise dos{" "}
              <strong>projetos industriais</strong>,{" "}
              <strong>fluxogramas produtivos</strong> e definição dos{" "}
              <strong>setores operacionais</strong>, garantindo consistência
              técnica mesmo sem dados reais de operação. A partir dessa análise,
              foram identificados os{" "}
              <strong>pontos geradores de resíduos</strong> em todas as áreas do
              empreendimento, permitindo antecipar os fluxos de geração e
              estruturar a gestão de forma precisa.
            </p>

            <p>
              A caracterização e classificação dos resíduos seguiram as
              diretrizes da <strong>ABNT</strong>, com destaque para a{" "}
              <strong>NBR 10004:2024</strong> e demais legislações aplicáveis,
              incluindo a distinção entre <strong>resíduos industriais</strong>{" "}
              e <strong>resíduos de serviços de saúde</strong>, assegurando
              estratégias adequadas para cada tipologia.
            </p>

            <p>
              Com base nesse diagnóstico, foi estruturado um{" "}
              <strong>sistema completo de gerenciamento de resíduos</strong>,
              contemplando todas as etapas operacionais, desde a geração até a
              destinação final. O plano incluiu diretrizes para{" "}
              <strong>redução na fonte</strong>, <strong>segregação</strong>,{" "}
              <strong>acondicionamento</strong>,{" "}
              <strong>transporte interno</strong>,{" "}
              <strong>armazenamento temporário</strong> e{" "}
              <strong>destinação final com rastreabilidade via MTR</strong>.
            </p>

            <p>
              Também foram incorporadas ações de{" "}
              <strong>educação ambiental</strong> para capacitação das equipes,
              além de diretrizes para <strong>monitoramento contínuo</strong>,
              definição de <strong>indicadores</strong>,{" "}
              <strong>revisão periódica</strong> e procedimentos de{" "}
              <strong>prevenção de emergências</strong>, garantindo a melhoria
              contínua da gestão de resíduos.
            </p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>
              Segurança ambiental, conformidade legal e otimização operacional
            </h5>
            <p>
              A elaboração do{" "}
              <strong>Plano de Gerenciamento de Resíduos Sólidos (PGRS)</strong>{" "}
              permitiu estruturar, ainda na fase de projeto, um{" "}
              <strong>
                sistema completo e eficiente de gestão de resíduos
              </strong>
              , garantindo <strong>segurança ambiental</strong>,{" "}
              <strong>conformidade legal</strong> e{" "}
              <strong>organização operacional</strong> desde o início do
              empreendimento.
            </p>

            <p className="subtitulo-descricao">
              <strong>Principais resultados alcançados:</strong>
            </p>

            <ul className="lista-servico-detalhada">
              <li>
                <strong>Atendimento integral às exigências técnicas</strong>{" "}
                para instrução do processo de Licença de Instalação;
              </li>
              <li>
                <strong>
                  Identificação e caracterização de 100% dos setores geradores
                  de resíduos
                </strong>
                , assegurando controle completo das fontes de geração;
              </li>
              <li>
                <strong>
                  Definição de um fluxo estruturado de gerenciamento
                </strong>
                , abrangendo todas as etapas, da geração à destinação final;
              </li>
              <li>
                <strong>Redução significativa dos riscos ambientais</strong>,
                especialmente relacionados à disposição inadequada de resíduos;
              </li>
              <li>
                <strong>
                  Potencial de redução de até 20% na geração de resíduos
                </strong>
                , a partir da aplicação de práticas de minimização na fonte;
              </li>
              <li>
                <strong>Otimização de recursos</strong>, com possibilidade de
                reaproveitamento e valorização de resíduos, gerando ganhos
                operacionais e econômicos.
              </li>
            </ul>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>
              Benefícios para o Empreendimento: Redução de riscos, custos e
              impactos ambientais
            </h5>
            <p>
              O desenvolvimento do projeto evidenciou a importância de integrar
              a <strong>gestão de resíduos</strong> ainda na fase de concepção
              do empreendimento, garantindo{" "}
              <strong>maior eficiência operacional</strong>,{" "}
              <strong>redução de riscos</strong> e melhor preparo para o{" "}
              <strong>atendimento às exigências legais</strong> ao longo de toda
              a operação. Também se destacou a necessidade de{" "}
              <strong>alinhamento entre equipes multidisciplinares</strong> e da
              realização de <strong>revisões periódicas do PGRS</strong>, com
              base em dados reais, assegurando a{" "}
              <strong>melhoria contínua do sistema de gestão</strong>.
            </p>

            <p>
              Mais do que viabilizar o avanço no{" "}
              <strong>licenciamento ambiental</strong>, o <strong>PGRS</strong>{" "}
              se consolidou como uma <strong>ferramenta estratégica</strong>,
              contribuindo para a{" "}
              <strong>redução de impactos ambientais</strong>,{" "}
              <strong>otimização de recursos</strong> e{" "}
              <strong>geração de valor ao negócio</strong>, reforçando a gestão
              integrada de resíduos como um dos pilares para a{" "}
              <strong>sustentabilidade</strong> e a{" "}
              <strong>competitividade das organizações</strong>.
            </p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>
              Como o PGRS se torna uma ferramenta estratégica para o negócio
            </h5>
            <p>
              O projeto possibilitou não apenas o avanço no{" "}
              <strong>processo de licenciamento ambiental</strong>, mas também a
              estruturação de uma <strong>base sólida</strong> para uma operação
              mais{" "}
              <strong>eficiente, segura e ambientalmente responsável</strong>.
            </p>

            <p>
              Mais do que atender a uma exigência legal, o{" "}
              <strong>Plano de Gerenciamento de Resíduos Sólidos (PGRS)</strong>{" "}
              consolidou-se como uma{" "}
              <strong>ferramenta estratégica de gestão</strong>, contribuindo
              para a <strong>redução de impactos ambientais</strong>,{" "}
              <strong>otimização de recursos</strong> e{" "}
              <strong>geração de valor ao negócio</strong>.
            </p>

            <p>
              A metodologia aplicada apresenta{" "}
              <strong>alto potencial de replicação</strong> em empreendimentos
              industriais, especialmente no <strong>setor de bioenergia</strong>
              , reforçando o papel da{" "}
              <strong>gestão integrada de resíduos</strong> como um dos pilares
              para a <strong>sustentabilidade</strong> e a{" "}
              <strong>competitividade das organizações</strong>.
            </p>
          </div>

          <div className="cta-container">
            <div className="cta-text">
              <h3>Precisa elaborar um PGRS?</h3>

              <p>
                Se a sua empresa precisa elaborar ou revisar um Plano de
                Gerenciamento de Resíduos Sólidos (PGRS), contar com suporte
                técnico especializado é essencial para garantir conformidade com
                a legislação ambiental, reduzir riscos e otimizar a gestão de
                resíduos no dia a dia.
              </p>

              <p>
                A Âmbar desenvolve soluções completas e personalizadas, atuando
                desde a estruturação do PGRS até o suporte na sua implementação,
                sempre alinhada às exigências dos órgãos ambientais e às
                melhores práticas do setor.
              </p>

              <p>
                Entre em contato e veja como podemos ajudar seu empreendimento a
                operar com mais segurança, eficiência e controle ambiental.
              </p>
            </div>

            <div className="cta-button-wrapper">
              <a
                href="https://wa.me/5532984053160?text=Olá, gostaria de solicitar um orçamento para elaboração de um Plano de Gerenciamento de Resíduos Sólidos (PGRS)"
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
              >
                Orçamento
              </a>
            </div>
          </div>
        </section>
      </main>
      <Projetos />
      <Servicos />
      <Contato />
    </div>
  );
}

export default ProjetoGereciamentoResiduosSolidos;
